function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Distribution'))  {
    return [
    {
      title: 'Distribution',
      icon: 'mdi-truck',
      items: [
        {
          icon: 'mdi-barcode-scan',
          title: 'Products',
          path: '/DIsProducts'
        },
        {
          icon: 'mdi-package-variant',
          title: 'Inventory',
          path: '/DIsInventory'
        },
        {
          icon: 'mdi-cart-outline',
          title: 'Create Order',
          path: '/DisCart'
        },
        {
          icon: 'mdi-cash-usd',
          title: 'Orders',
          path: '/DisSales'
        },
        
        // {
        //   icon: 'mdi-file-document-outline',
        //   title: 'Reports',
        //   path: '/DisReports'
        // }
      ]
    }
  ] } else return []
}

export default buildMenu